module.exports = __webpack_public_path__ + "static/media/Cube.9a4ad195.svg";